import axios from 'axios';
import moment from 'moment';
import { ROOT_API_URL } from '../app.config';
import { getHeaders } from "./index";

const TOKEN = 'token';
const USER_ID = 'user_id';
export const AUTH_URL = `${ROOT_API_URL}/auth/api-token-auth/`;
export const CHANGE_PASSWORD_URL = `${ROOT_API_URL}/auth/api-change-password/`;
export const RECOVER_ACCOUNT_URL = `${ROOT_API_URL}/auth/recover-account/`;
export const RECOVER_ACCOUNT_BY_EMAIL_URL = `${ROOT_API_URL}/auth/password_reset/`;
export const DELETE_USER_URL = `${ROOT_API_URL}/auth/api-delete-user/`;
export const FACEBOOK_AUTH_URL = `${ROOT_API_URL}/auth/api-fb-auth/`;
export const REGISTER_URL = `${ROOT_API_URL}/auth/api-create-user/`;
export const RESET_PASSWORD_URL = `${ROOT_API_URL}/auth/password_reset/confirm/`;
export const RESET_PASSWORD_AFTER_CODE_URL = `${ROOT_API_URL}/auth/reset-password-after-code/`;
export const TOKEN_VERIFY_URL = `${ROOT_API_URL}/auth/api-token-verify/`;

export const loginRequest = (username, password) => {
  return axios.post(AUTH_URL, { username, password });
};

export const resetPasswordRequest = payload => {
  return axios.post(RESET_PASSWORD_URL, payload);
};

export const resetPasswordAfterCodeRequest = payload => {
  return axios.post(RESET_PASSWORD_AFTER_CODE_URL, payload);
};

export const recoverAccountRequest = user_data => {
  return axios.post(RECOVER_ACCOUNT_URL, user_data);
};

export const recoverAccountByEmailRequest = email => {
  return axios.post(RECOVER_ACCOUNT_BY_EMAIL_URL, email);
};

export const deleteAccountRequest = () => {
  return axios.post(DELETE_USER_URL, {}, {
    headers: getHeaders()
  });
};

export const changePasswordRequest = data => {
  return axios.put(CHANGE_PASSWORD_URL, data, {
    headers: getHeaders()
  });
};

export const faceBookLoginRequest = accessToken => {
  return axios.post(FACEBOOK_AUTH_URL, { accessToken });
};

export const registerRequest = (username, password) => {
  return axios.post(REGISTER_URL, { username, password });
};

export const validateToken = (token, user_id) => {
  return axios.post(TOKEN_VERIFY_URL, { token, user_id });
};

export const clearToken = () => {
  localStorage.removeItem(TOKEN);
};

export const getToken = () => {
  const token = localStorage.getItem(TOKEN);


  return token;
};

export const setToken = (token) => {
  localStorage.setItem(TOKEN, token);
};

export const clearUserId = () => {
  localStorage.removeItem(USER_ID);
};

export const getUserId = () => {
  return localStorage.getItem(USER_ID);
};

export const setUserId = (userId) => {
  localStorage.setItem(USER_ID, userId);
};

const _redirectToLogin = () => window.location.replace('/logout');

const getJWTClaims = jwt => {
  try {
    return (
      jwt &&
      JSON.parse(
        atob(
          jwt
            .split('.')[1]
            .replace('-', '+')
            .replace('_', '/'),
        ),
      )
    );
  } catch (e) {
    _redirectToLogin();
    return {};
  }
};

export const getJWTClaim = key => {
  const jwt = getToken();
  return jwt ? getJWTClaims(jwt)[key] : null;
};


export const getTokenExpiration = () => getJWTClaim('exp') || 0;

export const isAuthenticated = () => getTokenExpiration() - moment().unix() > 0;



// WEBPACK FOOTER //
// ./src/services/auth.service.js